import { createContext, useContext, useState, ReactNode } from 'react';
import styled from '@emotion/styled';
import { keyframes } from '@emotion/react';

const fadeIn = keyframes`
    from {
        opacity: 0;
    }
    to {
        opacity: 1;
    }
`;

const rotate = keyframes`
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
`;

const dotAnimation = keyframes`
    0%, 100% {
        opacity: 0;
    }
    50% {
        opacity: 1;
    }
`;

const LoadingOverlay = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;
    animation: ${fadeIn} 0.3s ease-in-out;
    touch-action: none;
    pointer-events: auto;
`;

const LoadingSpinner = styled.div`
    width: 50px;
    height: 50px;
    border: 5px solid rgba(255, 255, 255, 0.3);
    border-radius: 50%;
    border-top-color: #fff;
    animation: ${rotate} 1s ease-in-out infinite;
`;

const LoadingContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 20px;
`;

// const DotsContainer = styled.div`
//     display: flex;
//     gap: 8px;
// `;

// const Dot = styled.div<{ delay: number }>`
//     width: 8px;
//     height: 8px;
//     border-radius: 50%;
//     background-color: white;
//     animation: ${dotAnimation} 1.5s ease-in-out infinite;
//     animation-delay: ${(props) => props.delay}s;
// `;

const Loading: React.FC = () => {
    return (
        <LoadingOverlay>
            <LoadingContainer>
                <LoadingSpinner />
                {/* <DotsContainer>
                    <Dot delay={0} />
                    <Dot delay={0.2} />
                    <Dot delay={0.4} />
                </DotsContainer> */}
            </LoadingContainer>
        </LoadingOverlay>
    );
};

interface LoadingContextType {
    loading: boolean;
    setLoading: (loading: boolean) => void;
}

const LoadingContext = createContext<LoadingContextType | undefined>(undefined);

export const LoadingProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
    const [loading, setIsLoading] = useState(false);

    const setLoading = (loading: boolean) => {
        setIsLoading(loading);
    };

    return (
        <LoadingContext.Provider value={{ loading, setLoading }}>
            {children}
            {loading && <Loading />}
        </LoadingContext.Provider>
    );
};

export const useLoading = () => {
    const context = useContext(LoadingContext);
    if (context === undefined) {
        throw new Error('useLoading must be used within a LoadingProvider');
    }
    return context;
};
